(()=>{
  if(window.egiftsMagnetCartV4Ready) return;
  window.egiftsMagnetCartV4Ready=true;

  let lightbox=null;

  const ensureLightbox=()=>{
    if(lightbox && document.body.contains(lightbox)) return lightbox;
    lightbox=document.createElement('div');
    lightbox.className='egifts-magnet-lightbox';
    lightbox.hidden=true;
    lightbox.innerHTML='<div class="egifts-magnet-lightbox__box" role="dialog" aria-modal="true" aria-label="Podgląd zdjęcia"><button type="button" class="egifts-magnet-lightbox__close" aria-label="Zamknij">×</button><img class="egifts-magnet-lightbox__image" alt="Podgląd przesłanego zdjęcia"></div>';
    document.body.appendChild(lightbox);
    return lightbox;
  };

  const closePreview=()=>{
    const modal=ensureLightbox();
    modal.hidden=true;
    modal.querySelector('.egifts-magnet-lightbox__image')?.removeAttribute('src');
    document.documentElement.style.overflow='';
  };

  document.addEventListener('click',(event)=>{
    const button=event.target.closest('[data-egifts-magnet-preview-open]');
    if(button){
      event.preventDefault();
      event.stopPropagation();
      const url=button.dataset.imageUrl||'';
      if(!url) return;
      const modal=ensureLightbox();
      modal.querySelector('.egifts-magnet-lightbox__image').src=url;
      modal.hidden=false;
      document.documentElement.style.overflow='hidden';
      modal.querySelector('.egifts-magnet-lightbox__close')?.focus();
      return;
    }

    if(lightbox && (event.target===lightbox || event.target.closest('.egifts-magnet-lightbox__close'))) closePreview();
  });

  document.addEventListener('keydown',(event)=>{
    if(event.key==='Escape' && lightbox && !lightbox.hidden) closePreview();
  });
})();